import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyAq3OISQiuZtVK5w4AHY0Qz-fVcW_iVSuI",
    authDomain: "online-store-9dc9d.firebaseapp.com",
    projectId: "online-store-9dc9d",
    storageBucket: "online-store-9dc9d.appspot.com",
    messagingSenderId: "906654622206",
    appId: "1:906654622206:web:5bb4f4bcacc15e006a20af",
    measurementId: "G-7ZNRV6XHBP"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };